import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  DEFAUTL_MAX_LENGTH_INPUT,
  EMPTY_STRING,
  HEIGHT,
  KEY_NAMES,
  TEXT,
  TIMERS,
} from '@app/constants';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
  @Input() placeholder: string = EMPTY_STRING;
  @Input() type: string = TEXT;
  @Input() maxLength: string = DEFAUTL_MAX_LENGTH_INPUT;
  @Input() classes: string = EMPTY_STRING;
  @Input() height: string = HEIGHT.fourteenPixels;
  @Input() isWrong: boolean | string = false;
  @Output() fieldCurrentValue = new EventEmitter<string>();
  @Output() fieldBlur = new EventEmitter<string>();
  @Input() showError: string = EMPTY_STRING;
  @Input() isDisabled: boolean = false;
  @Input() extraClass = '';
  @Input() fieldValue: string = EMPTY_STRING;
  @Input() inputId?: string;
  @Input() label: string = EMPTY_STRING;
  @Input() name: string = EMPTY_STRING;
  @Input() radioValue: string = EMPTY_STRING;

  private typingTimer?: NodeJS.Timeout;
  private readonly delay: number = TIMERS.ThousandMS;

  ngOnInit(): void {
    this.fieldCurrentValue.subscribe((value) => {
      this.fieldValue = value;
    });
  }

  public changeFieldValue() {
    this.fieldCurrentValue.emit(this.fieldValue);
  }

  emitValue(event: KeyboardEvent) {
    if (event.key === KEY_NAMES.Enter) {
      event.preventDefault(); // Previene la acción predeterminada (recargar la página)
    } else {
      clearTimeout(this.typingTimer);

      this.typingTimer = setTimeout(() => {
        this.fieldBlur.emit(this.fieldValue);
      }, this.delay);
    }
  }

  onBlur() {
    this.fieldBlur.emit(this.fieldValue);
  }
}
